import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatatableService } from '../../../shared/services/datatable.service';
import { Router } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { IMyDpOptions } from 'mydatepicker';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { HttpParams } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import { DetalhamentoSimulacaoService } from './lista-simulacao.service';


@Component({
  selector: 'ngx-lista-simulacao',
  templateUrl: './lista-simulacao.component.html',
  styleUrls: ['./lista-simulacao.component.scss']
})
export class ListaSimulacaoComponent implements OnInit {

  @ViewChild('myTable', null)
  public myTable: DatatableComponent
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  public formListaSimulacao = null;
  public listaStatus = null;
  public tableLimit = 12;
  public rowData : any;
  public customLogin = null;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    //disableUntil: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1 }

  };

  constructor(
    private formBuilder: FormBuilder,
    private datatableService: DatatableService,
    private router: Router,
    private paginationService: SpringDatatablePaginationService,
    private dateUtilService: DateUtilService,
    private notifications: NotificationsService,
    private service: DetalhamentoSimulacaoService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listaStatus = [

      {
        status: 'PENDENTE',
        descricao: 'PENDENTE'
      },
      {
        status: 'EXPIRADO',
        descricao: 'EXPIRADO'
      },
      {
        status: 'CONFIRMADO',
        descricao: 'CONFIRMADO'
      },
      {
        status: 'CANCELADO',
        descricao: 'CANCELADO'
      },
      {
        status: 'ESTORNADO',
        descricao: 'ESTORNADO'
      },
      {
        status: 'SIMULADO',
        descricao: 'SIMULADO'
      },
    ];

    this.formListaSimulacao = this.formBuilder.group({

      status: [null],
      dataEntrada: [null],
      dataFim: [null],

    });


  }

  listaVenda(data?: any, page?: string) {


    let params = new HttpParams();
    params = params.append('size', String(this.tableLimit))

    if (page) {
      params = params.append('page', page)
    }

    if (data.status != null) {
      params = params.append('status', data.status)
    }

    if (data.dataEntrada != null) {
      params = params.append('dataEntrada', data.dataEntrada)
    }

    if (data.dataFim != null) {
      params = params.append('dataFim', data.dataFim)
    }


    this.service.searchPinSumulator(params, (response => {
      this.rowData = response.content
      this.rowData = this.rowData.map(data => {

        return {
          valorVenda: data.valorVenda,
          codigoSimulador: data.codigoSimulador,
          custoTaxa: data.custoTaxa,
          status: data.status,
          dataLancamento: moment(data.dataLancamento).format('DD/MM/YYYY'),

        }

      });
      this.paginationService.setInfo(response)

    }), null);

  }

  gotoCancelar(data) {


    let idSimulacao = data.id


    this.service.cancelaSimulacao(
      idSimulacao,
      (response) => {
        this.notifications.success("SIMULAÇÃO CANCELADA COM SUCESSO");
      }, (error) => {
        this.notifications.error(error.message);
      })

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
